import React from 'react';
import ParametroRatingClusterService from '../../../../lib/api/parametroRatingCluster/parametroRatingClusterService';
import TemplateParametro from '../shared/templateParametros/templateParametros';

class ParametroRatingCluster extends React.Component<{},{}> 
{
    constructor(props: any)
    {
        super(props);
        this.state = {};
    }

    baixarExcelCluster()
    {
        return ParametroRatingClusterService.obterExcel();
    }

    enviarParametrosEventGrid()
    {
        return ParametroRatingClusterService.enviarParametrosAoEventGrid();
    }

    render()
    {
        return (
            <TemplateParametro
                enviarParametrosEventGrid={this.enviarParametrosEventGrid}
                baixarExcelParametros={this.baixarExcelCluster}
                enviarExcelParametros={ParametroRatingClusterService.salvarExcelParametros}
                deletarExcelParametros={ParametroRatingClusterService.deletarExcelParametros}
                nomeDoArquivo='Parâmetro Rating Cluster'
            ></TemplateParametro>
        );
    }
}

export default ParametroRatingCluster;